import React, { useMemo, useState } from "react";

export default function DeletedUsersPanel({ rows = [] }) {
  const [sort, setSort] = useState({ key: "deleted_at", dir: "desc" });

  const sortedRows = useMemo(() => {
    const copy = [...rows];
    copy.sort((a, b) => compareValues(a, b, sort.key, sort.dir));
    return copy;
  }, [rows, sort]);

  return (
    <div>
      <h2 style={styles.title}>Deleted users</h2>
      <div style={styles.tableWrap}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>{sortHeader("Original ID", "original_user_id", sort, setSort)}</th>
              <th style={styles.th}>{sortHeader("Username", "name", sort, setSort)}</th>
              <th style={styles.th}>{sortHeader("Email", "email", sort, setSort)}</th>
              <th style={styles.th}>{sortHeader("Reason", "deleted_reason", sort, setSort)}</th>
              <th style={styles.th}>{sortHeader("Deleted", "deleted_at", sort, setSort)}</th>
            </tr>
          </thead>
          <tbody>
            {sortedRows.length ? sortedRows.map((row, idx) => (
              <tr key={`${row.id || row.original_user_id || "du"}-${idx}`}>
                <td style={styles.td}>{row.original_user_id ?? row.user_id ?? "-"}</td>
                <td style={styles.td}>{row.name || row.username || "-"}</td>
                <td style={styles.td}>{row.email || "-"}</td>
                <td style={styles.td}>{row.deleted_reason || row.reason || "-"}</td>
                <td style={styles.td}>{formatDate(row.deleted_at || row.created_at)}</td>
              </tr>
            )) : (
              <tr><td style={styles.empty} colSpan={5}>No deleted users logged.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function compareValues(a, b, key, dir) {
  const mult = dir === "asc" ? 1 : -1;
  if (key === "original_user_id") return mult * ((Number(a.original_user_id ?? a.user_id ?? 0)) - (Number(b.original_user_id ?? b.user_id ?? 0)));
  if (key === "deleted_at") return mult * (toTime(a.deleted_at || a.created_at) - toTime(b.deleted_at || b.created_at));
  const av = key === "deleted_reason" ? (a.deleted_reason || a.reason) : (a[key] || a.username);
  const bv = key === "deleted_reason" ? (b.deleted_reason || b.reason) : (b[key] || b.username);
  return mult * String(av || "").localeCompare(String(bv || ""), undefined, { sensitivity: "base", numeric: true });
}

function toTime(value) {
  const d = new Date(value || 0);
  return Number.isNaN(d.getTime()) ? 0 : d.getTime();
}

function formatDate(value) {
  if (!value) return "-";
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? String(value) : d.toLocaleString();
}

function sortHeader(label, key, sort, setSort) {
  const active = sort.key === key;
  const arrow = active ? (sort.dir === "asc" ? "▲" : "▼") : "↕";
  return (
    <button type="button" onClick={() => setSort((prev) => ({ key, dir: prev.key === key && prev.dir === "asc" ? "desc" : "asc" }))} style={styles.sortBtn}>
      {label} <span style={styles.arrow}>{arrow}</span>
    </button>
  );
}

const styles = {
  title: { margin: "0 0 14px", fontSize: 18, fontWeight: 800 },
  sortBtn: { background: "transparent", border: "none", padding: 0, fontWeight: 800, cursor: "pointer", color: "#111" },
  arrow: { fontSize: 11, marginLeft: 4, color: "#111" },
  tableWrap: { overflowX: "auto" },
  table: { width: "100%", borderCollapse: "collapse" },
  th: { textAlign: "left", padding: "14px 10px", borderBottom: "1px solid #e5e7eb", fontWeight: 800, whiteSpace: "nowrap", color: "#111" },
  td: { padding: "14px 10px", borderBottom: "1px solid #f0f0f0", verticalAlign: "top" },
  empty: { padding: 20, textAlign: "center", color: "#667085" },
};
